import {
  ExternalContent,
  NavigationContent,
} from "../Navigation/NavigationContent";

import { AppBarProps } from "./@types/AppBarProps";
import { MenuItem } from "../Navigation/MenuItem";
import { ProfileMenu } from "./profile";
import { useSession } from "next-auth/react";

export const AppBar = ({ props }: AppBarProps) => {
  const app_name = process.env.APP_TITLE
    ? process.env.APP_TITLE.split(" ")
    : ["Aplicação", "Dashoard"];

  const { data: session } = useSession();

  return (
    <div id="sideBar" className={props.state ? "toggled" : "full"}>
      <div id="AppBarFixer"></div>
      <div id="AppBar">
        <div className="sidebar-container filledGradientBackground">
          <div className="logoProvider ">
            <span>{app_name[0]}</span>
            <span>{app_name.length > 1 ? app_name[1] : ""}</span>
          </div>
          <div className="divider" />
          <div id="Profile">
            <ProfileMenu />
          </div>
          <div className="divider" style={{ marginTop: "0px" }} />
          <nav>
            {props.session &&
              NavigationContent(session).map((i, k) => {
                return <MenuItem key={k} props={i.props}></MenuItem>;
              })}
          </nav>
          <div className="divider" style={{ marginTop: "0px" }} />
          <nav>
            {ExternalContent.map((i, k) => {
              return <MenuItem key={k} props={i.props}></MenuItem>;
            })}
          </nav>
        </div>
      </div>
    </div>
  );
};
